import { render } from "./Documents.vue?vue&type=template&id=c06ad33a&scoped=true"
import script from "./Documents.vue?vue&type=script&lang=js"
export * from "./Documents.vue?vue&type=script&lang=js"

import "./Documents.vue?vue&type=style&index=0&id=c06ad33a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-c06ad33a"

export default script